import { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { onshape_autosave_factory } from './onshape-autosave';

export type ISavingLoading = ReturnType<typeof saving_loading_factory>;

export const saving_loading_factory = (app: IFrontendServiceContainer) => ({
    onshape_autosave: onshape_autosave_factory(app.state, app.authentication.session_type),
});

export * from './file-reader';
export * from './texture-loader';
